import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  Tooltip,
  keyframes,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import styled from "@emotion/styled";

// Animação de atenção
const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.07); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
`;

const PulseText = styled("span")({
  animation: `${pulse} 1s infinite`,
  fontWeight: 600,
  display: "inline-block",
});

export default function CouponCard({ coupon }) {
  const isExpired = new Date(coupon.finishedAt) < new Date();

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 2,
        border: isExpired ? "1px solid #ccc" : "1px solid #4caf50",
        backgroundColor: isExpired ? "#f9f9f9" : "#f6fff7",
        mt: 2,
        mb: 2,
      }}
    >
      <CardContent>

        {/* Lado esquerdo — ícone + nome + status */}
        <Box display="flex" alignItems="center" gap={1.5}>
          {/* <Chip
            label={"Ativo"}
            color={"success"}
            size="small"
          /> */}
          <Typography variant="subtitle2" fontWeight={500}>
            {coupon.description}
          </Typography>

          <Chip
            label={
              <span style={{ display: "flex", gap: 4 }}>
                <PulseText>Acabando!</PulseText> 
              </span>
            }
            color="error"
            // variant="outlined"
            size="small"
            sx={{ ml: 1, fontWeight: 600}}
          />
        </Box>
      </CardContent>

      {/* Lado direito — código e desconto */}
      <Box display="flex" alignItems="center" gap={1.5}>
        {coupon.discountPercentage && (
          <Chip
            label={`-${coupon.discountPercentage}%`}
            color="success"
            size="small"
          />
        )}
        {/* <Tooltip title="Código do cupom">
          <Chip
            label={coupon.code}
            color="primary"
            icon={<CheckCircleIcon />}
            variant="outlined"
            size="small"
          />
        </Tooltip> */}
      </Box>
    </Card>
  );
}
